import FormValidation from '@/js/components/forms/formValidation';
import GoogleMaps from '@/js/components/google_maps/map';

class EventsDetail {
  constructor() {
    this.dom = {
      mapEl: document.getElementById('event-map'),
      formEvent: document.getElementById('form-event'),
      discountToggle: document.querySelector('.js-discount-toggle'),
      discountWrapper: document.querySelector('.js-discount-code-wrapper'),
    };

    this.props = {
      mapMarkers: null,
      mapOptions: null,
      infoWindowContent: null,
    };

    this.components = {
      googleMaps: null,
      eventFormValidation: null,
    };

    this.events = {
      onMapLoaded: this.onMapLoaded.bind(this),
      onDiscountToggle: this.onDiscountToggle.bind(this),
    };

    this.mount();
  }

  mount() {
    if (this.dom.mapEl) {
      this.initMaps();
    }

    if (this.dom.formEvent) {
      this.components.eventFormValidation = new FormValidation(this.dom.formEvent);
    }

    if (this.dom.discountToggle && this.dom.discountWrapper) {
      this.dom.discountToggle.addEventListener('click', this.events.onDiscountToggle);
    }
  }

  onDiscountToggle() {
    const isHidden = this.dom.discountWrapper.classList.toggle('d-none');
    this.dom.discountToggle.setAttribute('aria-expanded', String(!isHidden));

    if (!isHidden) {
      const input = this.dom.discountWrapper.querySelector('input');
      if (input) input.focus();
    }
  }

  initMaps() {
    // parse props
    this.props.mapOptions = JSON.parse(this.dom.mapEl.dataset.options);
    this.props.mapMarkers = JSON.parse(this.dom.mapEl.dataset.markers);

    // listen to map loaded
    this.dom.mapEl.addEventListener('loaded', this.events.onMapLoaded);

    // create map instance
    this.components.googleMaps = new GoogleMaps(this.dom.mapEl, this.props.mapOptions);
  }

  onMapLoaded() {
    // add markers
    this.props.mapMarkers.forEach((marker) => {
      this.components.googleMaps.addMarker(marker);
    });
  }
}

if (document.getElementById('page-events-detail')) {
  // eslint-disable-next-line no-new
  new EventsDetail();
}
